<ng-container *ngIf="!isDialogMode">
  <app-breadcrumb></app-breadcrumb>

  <div class="bpaas-title">功能標題 (雙檔)</div>
</ng-container>

<p-menubar [model]="masterMenu" class="bpaas-master-menubar bpaas-dialog-top-sticky" [id]="parseToId('masterMenu')">
</p-menubar>

<div class="bpaas-content">
  <form [formGroup]="formGroup">
    <p-panel [showHeader]="false">
      <div class="card" #contentElement pBPaaSFocusTrap>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label class="bpaas-required">文字輸入</label>
            <input type="text" pInputText
              formControlName="input" [id]="parseToId('input')"
              [ngClass]="{'ng-dirty': formControlInvalid('input')}">
            <div *ngIf="formControlInvalid('input')">
              <small class="p-error"
                *ngIf="formControl('input').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label class="bpaas-required">選擇日期</label>
            <p-calendar [showIcon]="true" appendTo="body"
              formControlName="calendar" dateFormat="yy/mm/dd" dataType="string"
              placeholder="yyyy/mm/dd" [inputId]="parseToId('calendar')"
              [showOnFocus]="false"
              [ngClass]="{'ng-dirty': formControlInvalid('calendar')}">
            </p-calendar>
            <div *ngIf="formControlInvalid('calendar')">
              <small class="p-error"
                *ngIf="formControl('calendar').errors?.['required']">
                {{ 'message.validation.required' | translate }}
              </small>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>日期區間</label>
            <p-calendar [showIcon]="true" appendTo="body"
              dateFormat="yy/mm/dd" dataType="string"
              selectionMode="range" formControlName="calendarRange"
              [showOnFocus]="false"
              [inputId]="parseToId('calendarRange')">
            </p-calendar>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>數字輸入</label>
            <p-inputNumber formControlName="inputNumber" [inputId]="parseToId('inputNumber')"></p-inputNumber>
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label>下拉選單 (固定選項)</label>
            <p-dropdown *ngIf="langChangeVisible"
              [options]="exampleOptions"
              placeholder="{{ 'option.please-select' | translate }}" [showClear]="true"
              formControlName="dropdown" [inputId]="parseToId('dropdown')">
            </p-dropdown>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>自動完成</label>
            <p-autoComplete *ngIf="langChangeVisible"
              [suggestions]="exampleDataSuggestions"
              [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true"
              [showEmptyMessage]="true" emptyMessage="{{ 'table.no-records-found' | translate }}"
              (completeMethod)="searchExampleDataSuggestions($event)"
              (onClear)="autoCompleteCleared('autoComplete')"
              (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoComplete')"
              formControlName="autoComplete" [inputId]="parseToId('autoComplete')"
              field="{{ 'exampleDataName' | translateFieldName: 'exampleDataName' }}">
              <ng-template let-exampleData pTemplate="item">
                {{ exampleData.exampleDataCode }} {{ exampleData.exampleDataName | translateDataValue: exampleData : 'exampleDataName' }}
              </ng-template>
            </p-autoComplete>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>動態下拉 (資料少適用)</label>
            <p-dropdown *ngIf="langChangeVisible"
              [options]="dynamicOptions"
              optionLabel="{{ 'label' | translateFieldName: 'label' }}"
              optionValue="value"
              placeholder="{{ 'option.please-select' | translate }}" [showClear]="true"
              appendTo="body"
              formControlName="dynamicDropdown" [inputId]="parseToId('dynamicDropdown')">
            </p-dropdown>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <label>自動完成+下拉 (資料少適用)</label>
            <p-autoComplete *ngIf="langChangeVisible"
              [suggestions]="allExampleDataSuggestions"
              [forceSelection]="true"
              [minLength]="2" [delay]="300" [showClear]="true"
              [showEmptyMessage]="true" emptyMessage="{{ 'table.no-records-found' | translate }}"
              (completeMethod)="searchAllExampleDataSuggestions($event)"
              (onClear)="autoCompleteCleared('autoCompleteDropdown')"
              (onFocus)="autoCompleteFocus($event)"
              (onBlur)="autoCompleteBlur($event)"
              (onKeyUp)="autoCompleteKeyUp($event)"
              (onSelect)="autoCompleteCompleted('autoCompleteDropdown')"
              [dropdown]="true" dropdownMode="blank"
              formControlName="autoCompleteDropdown" [inputId]="parseToId('autoCompleteDropdown')"
              field="{{ 'exampleDataName' | translateFieldName: 'exampleDataName' }}">
              <ng-template let-exampleData pTemplate="item">
                {{ exampleData.exampleDataCode }} {{ exampleData.exampleDataName | translateDataValue: exampleData : 'exampleDataName' }}
              </ng-template>
            </p-autoComplete>
          </div>
        </div>
        <div class="grid p-fluid">
          <div class="col-12 md:col-3 lg:col-3">
            <label>自訂欄位驗證 ( 不能輸入 1 )</label>
            <input type="text" pInputText
              formControlName="custValidation" [id]="parseToId('custValidation')"
              [ngClass]="{'ng-dirty': formControlInvalid('custValidation')}">
            <div *ngIf="formControlInvalid('custValidation')">
              <small class="p-error"
                *ngIf="formControl('custValidation').errors?.['duplicate']">
                {{ 'message.validation.duplicate' | translate }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </p-panel>
  </form>

  <p-panel [showHeader]="false">
    <!-- Detail Menu Bar -->
    <p-menubar *ngIf="detailMenubarVisible()" [model]="detailMenu" class="bpaas-detail-menubar" [id]="parseToId('detailMenu')">
    </p-menubar>

    <!-- Table Tab Menu -->
    <p-tabMenu #detailTabMenuComponent [model]="detailTabs" styleClass="bpaas-table-tabmenu"
      (activeItemChange)="onDetailTabActiveItemChange($event)">
    </p-tabMenu>

    <!-- Table Component -->
    <p-table #tableComponent [value]="detailDatas"
      styleClass="p-datatable-gridlines p-datatable-sm p-datatable-striped"
      [selectionMode]="tableSelectionMode" [(selection)]="rowSelectedDatas"
      [dataKey]="rowDataKeyName" [selectionPageOnly]="true"
      [paginator]="true" [rows]="5" [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'table.paginator' | translate: {'first': '{first}', 'last': '{last}', 'totalRecords': '{totalRecords}' } }}"
      [rowsPerPageOptions]="[2, 5, 10]" scrollHeight="75vh" [scrollable]="true"
      (onRowSelect)="onRowSelect()" (onRowUnselect)="onRowUnselect()" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle()"
      stateStorage="session" [stateKey]="tableStateStorageName"
      [resizableColumns]="true" columnResizeMode="expand"
      [columns]="selectedColumns"
      [detailInViewStatus]="detailInViewStatus()"
      (onStateSave)="onDetailTableStateSave($event)"
      (onFilter)="onDetailTableFilter($event)">

      <!-- Table Header -->
      <ng-template pTemplate="header" let-columns>
        <tr id="bpaas-table-header">
          <!-- Table Header Checkbox -->
          <th alignFrozen="left" pFrozenColumn
            style="min-width: 42px !important; max-width: 42px !important; width: 42px !important; text-align: center;">
            <p-tableHeaderCheckbox *ngIf="tableSelectionMode == 'multiple'"
              [id]="parseToId('tableHeaderCheck')"></p-tableHeaderCheckbox>
          </th>

          <!-- Table Header Columns -->
          <th *ngFor="let column of columns"
            [pSortableColumn]="column.sortable ? column.field : ''"
            [pSortableColumnDisabled]="column.sortable ? false : true"
            [style]="column.width ? 'width: ' + column.width + 'px' : ''"
            pResizableColumn>
            <label [class]="column.required ? 'bpaas-required' : ''">
              {{ column.header | translate }}
            </label>
            <p-sortIcon *ngIf="column.sortable" [field]="column.field"></p-sortIcon>
          </th>

          <!-- Table Header Actions Column -->
          <th *ngIf="showActions" alignFrozen="right" pFrozenColumn
            style="min-width: 70px !important; max-width: 70px !important; width: 70px !important">
            Actions
          </th>
        </tr>

        <!-- Table Header Filter -->
        <tr *ngIf="tableFilterShow">
          <th alignFrozen="left" pFrozenColumn>
            &nbsp;
          </th>
          <th *ngFor="let column of columns">
            <ng-container *ngIf="column.filter">

              <ng-container [ngSwitch]="column.filter.type">
                <p-columnFilter [type]="column.filter.type"
                  [field]="column.filter.field ? column.filter.field : column.field"
                  [matchMode]="column.filter.matchMode ? column.filter.matchMode : 'contains'"
                  styleClass="w-full"
                  [showClearButton]="false"
                  [showButtons]="false"
                  [showMenu]="column.filter.type == 'dropdown' ? false : true">

                  <!-- Table Header Dropdown Filter -->
                  <ng-template *ngIf="column.filter.type == 'dropdown'"
                    pTemplate="filter" let-value let-filter="filterCallback">
                    <p-dropdown [ngModel]="value" [options]="column.filter.options"
                      [optionLabel]="column.filter.translateOptionFieldName ? ('label' | translateFieldName: 'label') : 'label'"
                      optionValue="value"
                      placeholder="Any"
                      (onChange)="filter($event.value)" [showClear]="true" appendTo="body">
                    </p-dropdown>
                  </ng-template>

                  <!-- Table Header Date Filter -->
                  <ng-template *ngIf="column.filter.type == 'date'"
                    pTemplate="filter" let-value let-filter="filterCallback">
                    <p-calendar #calendar [ngModel]="value"
                      (onSelect)="filter(calendar.value)"
                      (keydown.enter)="filter(calendar.value)"
                      dateFormat="yy/mm/dd" dataType="string"
                      appendTo="body">
                    </p-calendar>
                  </ng-template>
                </p-columnFilter>
              </ng-container>

            </ng-container>
          </th>
          <th alignFrozen="right" pFrozenColumn>
            &nbsp;
          </th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
        <tr [id]="parseToId('rowData-' + rowIndex)">
          <!-- Table Body Checkbox or RadioButton Column -->
          <td alignFrozen="left" pFrozenColumn
            style="min-width: 42px !important; max-width: 42px !important; width: 42px !important; text-align: center;">
            <p-tableRadioButton *ngIf="tableSelectionMode == 'single'" [value]="rowData" [id]="parseToId('rowData-' + rowIndex + '-radio')"></p-tableRadioButton>
            <p-tableCheckbox *ngIf="tableSelectionMode == 'multiple'" [value]="rowData" [id]="parseToId('rowData-' + rowIndex + '-check')"></p-tableCheckbox>
          </td>

          <!-- Table Body Data Display -->
          <td *ngFor="let column of tableColumns"
            [class]="column.numberField ? 'bpaas-align-right' : ''"
            [id]="parseToId('rowData-' + rowIndex + '-' + column.field)">
            <ng-container *ngIf="column.translateDataValueField && langChangeVisible">
              {{ rowData[column.field] | translateDataValue: rowData : column.translateDataValueField }}
            </ng-container>
            <ng-container *ngIf="column.translateArrayValue && langChangeVisible">
              {{ rowData[column.field] | translateArrayValue: column.translateArrayValue.datas : column.translateArrayValue.valueField : column.translateArrayValue.displayField }}
            </ng-container>
            <ng-container *ngIf="column.numberField">
              {{ (rowData[column.field] ?? (column.numberFieldDefaultZero ? 0 : '')) | dynamicDecimal }}
            </ng-container>
            <ng-container *ngIf="column.dateField">
              {{ rowData[column.field] | date: (column.dateFormat ? column.dateFormat : 'yyyy/MM/dd') : 'GMT+8' }}
            </ng-container>
            <ng-container *ngIf="column.customField">
              <!-- 如果有需要條件判斷處理值的，自己寫在這段裡面 -->
            </ng-container>
            <ng-container *ngIf="!column.customField && !column.translateDataValueField
              && !column.translateArrayValue && !column.numberField && !column.dateField">
              {{ rowData[column.field] }}
            </ng-container>
          </td>

          <!-- Table Body Actions Column -->
          <td *ngIf="showActions" alignFrozen="right" pFrozenColumn class="bpaas-align-center">
            <div>
              <p-menu #menu [popup]="true" [model]="rowActionMenu" appendTo="body"></p-menu>
              <button *ngIf="rowActionMenuVisible()"
                pButton type="button" class="p-button-outlined p-button-secondary" icon="pi pi-wrench"
                (click)="clickRowActionMenu(rowData); menu.toggle($event);" [id]="parseToId('btnActions')">
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="tableColumns.length + (showActions ? 2 : 1)">
            {{ 'table.no-records-found' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>
